/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_Li3Inputs */

const en_guide_json_rest_api_s5_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>ISO 8601</strong> format for dates: <code>"2024-01-15T10:30:00Z"</code>`)
};

const ko_guide_json_rest_api_s5_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜에는 <strong>ISO 8601</strong> 포맷을 사용하세요: <code>"2024-01-15T10:30:00Z"</code>`)
};

const ja_guide_json_rest_api_s5_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付には<strong>ISO 8601</strong>形式を使用してください：<code>"2024-01-15T10:30:00Z"</code>`)
};

/**
* | output |
* | --- |
* | "Use <strong>ISO 8601</strong> format for dates: <code>\"2024-01-15T10:30:00Z\"</code>" |
*
* @param {Guide_Json_Rest_Api_S5_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_li3 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_li3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_li3(inputs)
	return ja_guide_json_rest_api_s5_li3(inputs)
});